import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
    ChartComponent,
    ApexAxisChartSeries,
    ApexChart,
    ApexXAxis,
    ApexDataLabels,
    ApexTooltip,
    ApexStroke,
    ApexTitleSubtitle,
    ApexLegend,
    ApexFill,
    ApexMarkers,
    ApexYAxis
} from "ng-apexcharts";

type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
    yaxis: ApexYAxis;
    stroke: ApexStroke;
    tooltip: ApexTooltip;
    dataLabels: ApexDataLabels;
    title: ApexTitleSubtitle,
    legend: ApexLegend;
    fill: ApexFill
    markers: ApexMarkers;
};

@Component({
    selector: 'lib-spline-area-chart',
    templateUrl: './spline-area-chart.component.html',
})
export class SplineAreaChartComponent implements OnInit {



    @Input() type: any;
    @Input() categorias: any;
    @Input() data: any;
    @Input() nombre: string;
    @Input() title: string;
    @Input() colors: any;
    @Input() straight: boolean;

    @ViewChild("chart") chart: ChartComponent;
    public chartOptions: Partial<ChartOptions>;

    constructor(private readonly _translate: TranslateService) {

    }


    ngOnInit() {
        this.chartOptions = {
            series: this.data,
            chart: {
                height: 350,
                width: 1100,
                animations: {
                    enabled: false
                },
                type: this.type,
                fontFamily: 'medium',
                toolbar: {
                    show: true,
                    offsetX: 0,
                    offsetY: 0,
                    tools: {
                      download: true,
                      selection: false,
                      zoom: false,
                      zoomin: false,
                      zoomout: false,
                      reset: false,
                      pan: false
                    },
                    export: {
                      csv: {
                        filename: undefined,
                        columnDelimiter: ',',
                        headerCategory: 'category',
                        headerValue: 'value',
                        dateFormatter(timestamp) {
                          return new Date(timestamp).toDateString();
                        }
                      },
                    }
                  }
            },
            dataLabels: {
                enabled: false,
                style: {
                    colors: this.colors
                },
            },
            stroke: {
                curve: this.straight ? "straight" : "smooth",
                colors: this.colors
            },
            xaxis: {
                type: "category",
                categories: this.categorias,
                labels: {
                    show: true,
                    style: {
                        fontSize: '11.8px',
                        fontFamily: 'medium',
                        colors: '184d39'
                    },
                    formatter: (val) =>  {
                        return isNaN(+val) ? val : (((+val >= 2000 && +val <= 2200) ? parseInt(val).toString() : Number(val).toLocaleString(this._translate.getDefaultLang(), {minimumFractionDigits: 0, maximumFractionDigits: 0})));
                    }
                }
            },
            yaxis: {
                labels: {
                style: {
                    fontSize: '11.8px',
                    fontFamily: 'medium',
                    colors: '#184d39'
                },
                    formatter: (val) =>  {
                        return isNaN(+val) ? val.toString() : (((+val >= 2000 && +val <= 2200) ? parseInt(val.toString()).toString() : Number(val).toLocaleString(this._translate.getDefaultLang(), {minimumFractionDigits: 0, maximumFractionDigits: 0})));
                    }
                }
              },
            tooltip: {
                // x: {
                //     format: "yyyy"
                // },
                y: {
                    formatter: (val) => {
                      let dataLabel;
                      isNaN(+val) ? dataLabel = val.toString() +  + ' ' + this.nombre :
                        dataLabel = Number(val).toLocaleString(this._translate.getDefaultLang(), {minimumFractionDigits: 0, maximumFractionDigits: 0}) + ' ' + this.nombre;
                      return dataLabel;
                    }
                },
                theme: "light",
                marker: {
                    show: false
                }
            },
            title: {
                text: this.title ? this.title : undefined,
                align: 'center',
                offsetX: 0,
                offsetY: 0,
                floating: false,
                style: {
                    fontSize: '14px',
                    fontFamily: 'medium',
                    color: '#184d39'
                },
            },
            legend: {
                position: "top",
                horizontalAlign: "center",
                offsetX: 50,
                offsetY: 0,
                width: (950),
                markers: {
                    fillColors: this.colors
                },
                formatter: (val) => {
                    return isNaN(+val) ? val.toString().replace(',', '') :
                        Number(val).toLocaleString(this._translate.getDefaultLang(), {minimumFractionDigits: 0, maximumFractionDigits: 0}).toString().replace(',', '');
                  }
            },
            markers: {
                colors: this.colors
            },
            fill: {
                opacity: 1,
                colors:  this.colors
            },
        };
    }
}